import { AppCard, AppCardContent, AppCardMediaOverlay } from '@app/components/base/app-card';
import { FleetBalenaDeviceDto } from '@mi-front/api-v2';
import { BalenaDeviceCardFooter } from './BalenaDeviceCardFooter';
import { BalenaDeviceCardLocation } from './BalenaDeviceCardLocation';
import { BalenaDeviceCardMap } from './BalenaDeviceCardMap';
import { BalenaDeviceCardTitle } from './BalenaDeviceCardTitle';
import { BalenaDevicePublicUrlLink } from './BalenaDevicePublicUrlLink';
import { BalenaDeviceTypeChip } from './BalenaDeviceTypeChip';

/**
 * Non-interactive Balena device card: map thumb, type, status, location, optional AirNode URL.
 */
export function BalenaDeviceCard({ device }: { device: FleetBalenaDeviceDto }) {
  const showPublicUrl = device.type === 'airnode' && Boolean(device.publicUrl);

  return (
    <AppCard
      interactive={false}
      sx={{ border: 1, borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}
      media={
        <BalenaDeviceCardMap device={device}>
          <AppCardMediaOverlay overlayPosition="top-left">
            <BalenaDeviceTypeChip type={device.type} />
          </AppCardMediaOverlay>
        </BalenaDeviceCardMap>
      }
      footer={
        <BalenaDeviceCardFooter
          deviceId={device.id}
          isOnline={device.isOnline}
          lastSeenOnline={device.lastSeenOnline}
        />
      }
    >
      <AppCardContent sx={{ pt: 1.5, pb: 0, px: 2 }}>
        <BalenaDeviceCardTitle name={device.name} isOnline={device.isOnline} />
        <BalenaDeviceCardLocation
          location={device.location}
          lat={device.coords?.lat}
          lng={device.coords?.lng}
          mb={showPublicUrl ? 1 : 1.5}
        />
        {showPublicUrl ? <BalenaDevicePublicUrlLink publicUrl={device.publicUrl} /> : null}
      </AppCardContent>
    </AppCard>
  );
}
